export enum ProjectDetailTab {
  TEAM,
  APPLICATIONS,
  CANCELS,
  ADD,
}
